import { render, staticRenderFns } from "./CustomStarText.vue?vue&type=template&id=633372f2&scoped=true"
import script from "./CustomStarText.vue?vue&type=script&lang=js"
export * from "./CustomStarText.vue?vue&type=script&lang=js"
import style0 from "./CustomStarText.vue?vue&type=style&index=0&id=633372f2&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "633372f2",
  null
  
)

export default component.exports